import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.object.assign";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createMirror, snapshot } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';
import { EventType, IncrementalSource } from '../../../types/dist/rrweb-types.js';
import { polyfill, nowTimestamp, on, getWindowWidth, getWindowHeight, getWindowScroll, isSerializedIframe, isSerializedStylesheet, hasShadowRoot } from '../utils.js';
import { callbackWrapper, unregisterErrorHandler, registerErrorHandler } from './error-handler.js';
import { IframeManager } from './iframe-manager.js';
import { initObservers, mutationBuffers } from './observer.js';
import { CanvasManager } from './observers/canvas/canvas-manager.js';
import ProcessedNodeManager from './processed-node-manager.js';
import { ShadowDomManager } from './shadow-dom-manager.js';
import { StylesheetManager } from './stylesheet-manager.js';

function wrapEvent(e) {
  return Object.assign(Object.assign({}, e), {
    timestamp: nowTimestamp()
  });
}

var wrappedEmit;
var takeFullSnapshot;
var canvasManager;
var recording = false;
var mirror = createMirror();

function record() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var emit = options.emit,
      checkoutEveryNms = options.checkoutEveryNms,
      checkoutEveryNth = options.checkoutEveryNth,
      _options$blockClass = options.blockClass,
      blockClass = _options$blockClass === void 0 ? 'rr-block' : _options$blockClass,
      _options$blockSelecto = options.blockSelector,
      blockSelector = _options$blockSelecto === void 0 ? null : _options$blockSelecto,
      _options$ignoreClass = options.ignoreClass,
      ignoreClass = _options$ignoreClass === void 0 ? 'rr-ignore' : _options$ignoreClass,
      _options$ignoreSelect = options.ignoreSelector,
      ignoreSelector = _options$ignoreSelect === void 0 ? null : _options$ignoreSelect,
      _options$maskTextClas = options.maskTextClass,
      maskTextClass = _options$maskTextClas === void 0 ? 'rr-mask' : _options$maskTextClas,
      _options$maskTextSele = options.maskTextSelector,
      maskTextSelector = _options$maskTextSele === void 0 ? null : _options$maskTextSele,
      _options$inlineStyles = options.inlineStylesheet,
      inlineStylesheet = _options$inlineStyles === void 0 ? true : _options$inlineStyles,
      maskAllInputs = options.maskAllInputs,
      _maskInputOptions = options.maskInputOptions,
      _slimDOMOptions = options.slimDOMOptions,
      maskInputFn = options.maskInputFn,
      maskTextFn = options.maskTextFn,
      hooks = options.hooks,
      packFn = options.packFn,
      _options$sampling = options.sampling,
      sampling = _options$sampling === void 0 ? {} : _options$sampling,
      _options$dataURLOptio = options.dataURLOptions,
      dataURLOptions = _options$dataURLOptio === void 0 ? {} : _options$dataURLOptio,
      mousemoveWait = options.mousemoveWait,
      _options$recordDOM = options.recordDOM,
      recordDOM = _options$recordDOM === void 0 ? true : _options$recordDOM,
      _options$recordCanvas = options.recordCanvas,
      recordCanvas = _options$recordCanvas === void 0 ? false : _options$recordCanvas,
      _options$recordCrossO = options.recordCrossOriginIframes,
      recordCrossOriginIframes = _options$recordCrossO === void 0 ? false : _options$recordCrossO,
      _options$recordAfter = options.recordAfter,
      recordAfter = _options$recordAfter === void 0 ? options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load' : _options$recordAfter,
      _options$userTriggere = options.userTriggeredOnInput,
      userTriggeredOnInput = _options$userTriggere === void 0 ? false : _options$userTriggere,
      _options$collectFonts = options.collectFonts,
      collectFonts = _options$collectFonts === void 0 ? false : _options$collectFonts,
      _options$inlineImages = options.inlineImages,
      inlineImages = _options$inlineImages === void 0 ? false : _options$inlineImages,
      plugins = options.plugins,
      _options$keepIframeSr = options.keepIframeSrcFn,
      keepIframeSrcFn = _options$keepIframeSr === void 0 ? function () {
    return false;
  } : _options$keepIframeSr,
      _options$ignoreCSSAtt = options.ignoreCSSAttributes,
      ignoreCSSAttributes = _options$ignoreCSSAtt === void 0 ? new Set([]) : _options$ignoreCSSAtt,
      errorHandler = options.errorHandler;
  registerErrorHandler(errorHandler);
  var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
  var passEmitsToParent = false;

  if (!inEmittingFrame) {
    try {
      if (window.parent.document) {
        passEmitsToParent = false;
      }
    } catch (e) {
      passEmitsToParent = true;
    }
  }

  if (inEmittingFrame && !emit) {
    throw new Error('emit function is required');
  }

  if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
    sampling.mousemove = mousemoveWait;
  }

  mirror.reset();
  var maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    'datetime-local': true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    password: true
  } : _maskInputOptions !== undefined ? _maskInputOptions : {
    password: true
  };
  var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaVerification: true,
    headMetaAuthorship: _slimDOMOptions === 'all',
    headMetaDescKeywords: _slimDOMOptions === 'all'
  } : _slimDOMOptions ? _slimDOMOptions : {};
  polyfill();
  var lastFullSnapshotEvent;
  var incrementalSnapshotCount = 0;

  var eventProcessor = function eventProcessor(e) {
    var _iterator = _createForOfIteratorHelper(plugins || []),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var plugin = _step.value;

        if (plugin.eventProcessor) {
          e = plugin.eventProcessor(e);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (packFn && !passEmitsToParent) {
      e = packFn(e);
    }

    return e;
  };

  wrappedEmit = function wrappedEmit(e, isCheckout) {
    var _a;

    if (((_a = mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== EventType.FullSnapshot && !(e.type === EventType.IncrementalSnapshot && e.data.source === IncrementalSource.Mutation)) {
      mutationBuffers.forEach(function (buf) {
        return buf.unfreeze();
      });
    }

    if (inEmittingFrame) {
      emit === null || emit === void 0 ? void 0 : emit(eventProcessor(e), isCheckout);
    } else if (passEmitsToParent) {
      var message = {
        type: 'rrweb',
        event: eventProcessor(e),
        origin: window.location.origin,
        isCheckout: isCheckout
      };
      window.parent.postMessage(message, '*');
    }

    if (e.type === EventType.FullSnapshot) {
      lastFullSnapshotEvent = e;
      incrementalSnapshotCount = 0;
    } else if (e.type === EventType.IncrementalSnapshot) {
      if (e.data.source === IncrementalSource.Mutation && e.data.isAttachIframe) {
        return;
      }

      incrementalSnapshotCount++;
      var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
      var exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;

      if (exceedCount || exceedTime) {
        takeFullSnapshot(true);
      }
    }
  };

  var wrappedMutationEmit = function wrappedMutationEmit(m) {
    wrappedEmit(wrapEvent({
      type: EventType.IncrementalSnapshot,
      data: Object.assign({
        source: IncrementalSource.Mutation
      }, m)
    }));
  };

  var wrappedScrollEmit = function wrappedScrollEmit(p) {
    return wrappedEmit(wrapEvent({
      type: EventType.IncrementalSnapshot,
      data: Object.assign({
        source: IncrementalSource.Scroll
      }, p)
    }));
  };

  var wrappedCanvasMutationEmit = function wrappedCanvasMutationEmit(p) {
    return wrappedEmit(wrapEvent({
      type: EventType.IncrementalSnapshot,
      data: Object.assign({
        source: IncrementalSource.CanvasMutation
      }, p)
    }));
  };

  var wrappedAdoptedStyleSheetEmit = function wrappedAdoptedStyleSheetEmit(a) {
    return wrappedEmit(wrapEvent({
      type: EventType.IncrementalSnapshot,
      data: Object.assign({
        source: IncrementalSource.AdoptedStyleSheet
      }, a)
    }));
  };

  var stylesheetManager = new StylesheetManager({
    mutationCb: wrappedMutationEmit,
    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
  });
  var iframeManager = new IframeManager({
    mirror: mirror,
    mutationCb: wrappedMutationEmit,
    stylesheetManager: stylesheetManager,
    recordCrossOriginIframes: recordCrossOriginIframes,
    wrappedEmit: wrappedEmit
  });

  var _iterator2 = _createForOfIteratorHelper(plugins || []),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var plugin = _step2.value;
      if (plugin.getMirror) plugin.getMirror({
        nodeMirror: mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var processedNodeManager = new ProcessedNodeManager();
  canvasManager = new CanvasManager({
    recordCanvas: recordCanvas,
    mutationCb: wrappedCanvasMutationEmit,
    win: window,
    blockClass: blockClass,
    blockSelector: blockSelector,
    mirror: mirror,
    sampling: sampling.canvas,
    dataURLOptions: dataURLOptions
  });
  var shadowDomManager = new ShadowDomManager({
    mutationCb: wrappedMutationEmit,
    scrollCb: wrappedScrollEmit,
    bypassOptions: {
      blockClass: blockClass,
      blockSelector: blockSelector,
      maskTextClass: maskTextClass,
      maskTextSelector: maskTextSelector,
      inlineStylesheet: inlineStylesheet,
      maskInputOptions: maskInputOptions,
      dataURLOptions: dataURLOptions,
      maskTextFn: maskTextFn,
      maskInputFn: maskInputFn,
      recordCanvas: recordCanvas,
      inlineImages: inlineImages,
      sampling: sampling,
      slimDOMOptions: slimDOMOptions,
      iframeManager: iframeManager,
      stylesheetManager: stylesheetManager,
      canvasManager: canvasManager,
      keepIframeSrcFn: keepIframeSrcFn,
      processedNodeManager: processedNodeManager
    },
    mirror: mirror
  });

  takeFullSnapshot = function takeFullSnapshot() {
    var isCheckout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!recordDOM) {
      return;
    }

    wrappedEmit(wrapEvent({
      type: EventType.Meta,
      data: {
        href: window.location.href,
        width: getWindowWidth(),
        height: getWindowHeight()
      }
    }), isCheckout);
    stylesheetManager.reset();
    shadowDomManager.init();
    mutationBuffers.forEach(function (buf) {
      return buf.lock();
    });
    var node = snapshot(document, {
      mirror: mirror,
      blockClass: blockClass,
      blockSelector: blockSelector,
      maskTextClass: maskTextClass,
      maskTextSelector: maskTextSelector,
      inlineStylesheet: inlineStylesheet,
      maskAllInputs: maskInputOptions,
      maskTextFn: maskTextFn,
      maskInputFn: maskInputFn,
      slimDOM: slimDOMOptions,
      dataURLOptions: dataURLOptions,
      recordCanvas: recordCanvas,
      inlineImages: inlineImages,
      onSerialize: function onSerialize(n) {
        if (isSerializedIframe(n, mirror)) {
          iframeManager.addIframe(n);
        }

        if (isSerializedStylesheet(n, mirror)) {
          stylesheetManager.trackLinkElement(n);
        }

        if (hasShadowRoot(n)) {
          shadowDomManager.addShadowRoot(n.shadowRoot, document);
        }
      },
      onIframeLoad: function onIframeLoad(iframe, childSn) {
        iframeManager.attachIframe(iframe, childSn);
        shadowDomManager.observeAttachShadow(iframe);
      },
      onStylesheetLoad: function onStylesheetLoad(linkEl, childSn) {
        stylesheetManager.attachLinkElement(linkEl, childSn);
      },
      keepIframeSrcFn: keepIframeSrcFn
    });

    if (!node) {
      return console.warn('Failed to snapshot the document');
    }

    wrappedEmit(wrapEvent({
      type: EventType.FullSnapshot,
      data: {
        node: node,
        initialOffset: getWindowScroll(window)
      }
    }), isCheckout);
    mutationBuffers.forEach(function (buf) {
      return buf.unlock();
    });
    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
  };

  try {
    var handlers = [];

    var observe = function observe(doc) {
      var _a;

      return callbackWrapper(initObservers)({
        mutationCb: wrappedMutationEmit,
        mousemoveCb: function mousemoveCb(positions, source) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: {
              source: source,
              positions: positions
            }
          }));
        },
        mouseInteractionCb: function mouseInteractionCb(d) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.MouseInteraction
            }, d)
          }));
        },
        scrollCb: wrappedScrollEmit,
        viewportResizeCb: function viewportResizeCb(d) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.ViewportResize
            }, d)
          }));
        },
        inputCb: function inputCb(v) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.Input
            }, v)
          }));
        },
        mediaInteractionCb: function mediaInteractionCb(p) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.MediaInteraction
            }, p)
          }));
        },
        styleSheetRuleCb: function styleSheetRuleCb(r) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.StyleSheetRule
            }, r)
          }));
        },
        styleDeclarationCb: function styleDeclarationCb(r) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.StyleDeclaration
            }, r)
          }));
        },
        canvasMutationCb: wrappedCanvasMutationEmit,
        fontCb: function fontCb(p) {
          return wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.Font
            }, p)
          }));
        },
        selectionCb: function selectionCb(p) {
          wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({
              source: IncrementalSource.Selection
            }, p)
          }));
        },
        blockClass: blockClass,
        ignoreClass: ignoreClass,
        ignoreSelector: ignoreSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        maskInputOptions: maskInputOptions,
        inlineStylesheet: inlineStylesheet,
        sampling: sampling,
        recordDOM: recordDOM,
        recordCanvas: recordCanvas,
        inlineImages: inlineImages,
        userTriggeredOnInput: userTriggeredOnInput,
        collectFonts: collectFonts,
        doc: doc,
        maskInputFn: maskInputFn,
        maskTextFn: maskTextFn,
        keepIframeSrcFn: keepIframeSrcFn,
        blockSelector: blockSelector,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        mirror: mirror,
        iframeManager: iframeManager,
        stylesheetManager: stylesheetManager,
        shadowDomManager: shadowDomManager,
        processedNodeManager: processedNodeManager,
        canvasManager: canvasManager,
        ignoreCSSAttributes: ignoreCSSAttributes,
        plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter(function (p) {
          return p.observer;
        })) === null || _a === void 0 ? void 0 : _a.map(function (p) {
          return {
            observer: p.observer,
            options: p.options,
            callback: function callback(payload) {
              return wrappedEmit(wrapEvent({
                type: EventType.Plugin,
                data: {
                  plugin: p.name,
                  payload: payload
                }
              }));
            }
          };
        })) || []
      }, hooks);
    };

    iframeManager.addLoadListener(function (iframeEl) {
      try {
        handlers.push(observe(iframeEl.contentDocument));
      } catch (error) {
        console.warn(error);
      }
    });

    var init = function init() {
      takeFullSnapshot();
      handlers.push(observe(document));
      recording = true;
    };

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      init();
    } else {
      handlers.push(on('DOMContentLoaded', function () {
        wrappedEmit(wrapEvent({
          type: EventType.DomContentLoaded,
          data: {}
        }));
        if (recordAfter === 'DOMContentLoaded') init();
      }));
      handlers.push(on('load', function () {
        wrappedEmit(wrapEvent({
          type: EventType.Load,
          data: {}
        }));
        if (recordAfter === 'load') init();
      }, window));
    }

    return function () {
      handlers.forEach(function (h) {
        return h();
      });
      processedNodeManager.destroy();
      recording = false;
      unregisterErrorHandler();
    };
  } catch (error) {
    console.warn(error);
  }
}

record.addCustomEvent = function (tag, payload) {
  if (!recording) {
    throw new Error('please add custom event after start recording');
  }

  wrappedEmit(wrapEvent({
    type: EventType.Custom,
    data: {
      tag: tag,
      payload: payload
    }
  }));
};

record.freezePage = function () {
  mutationBuffers.forEach(function (buf) {
    return buf.freeze();
  });
};

record.takeFullSnapshot = function (isCheckout) {
  if (!recording) {
    throw new Error('please take full snapshot after start recording');
  }

  takeFullSnapshot(isCheckout);
};

record.mirror = mirror;
export { record as default };